import React, { FunctionComponent } from "react";

import { KeyboardKeyInfo } from "../models/KeyboardKeyInfo";
import { KeyboardKey } from "./";

import "./KeyboardRow.scss";

interface KeyboardRowProps {
    data: KeyboardKeyInfo[];
    isShift: boolean;
    onShiftClick: () => void;
}

export const KeyboardRow: FunctionComponent<KeyboardRowProps> = ({
    data,
    isShift,
    onShiftClick,
}) => {
    return (
        <div className="keyboard_row">
            {data.map((keyData, idx) => (
                <KeyboardKey
                    key={idx}
                    data={keyData}
                    isShift={isShift}
                    onShiftClick={onShiftClick}
                />
            ))}
        </div>
    );
};
